import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const smarteldsConfig: TSPConfig = {
  key: 'smartelds',
  name: 'SmartELDs',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your SmartELDs API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default smarteldsConfig;
